<template>
  <div class="gamburger" id="gamburger" v-on="$listeners">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean
  },
  updated() {
    if(this.active) {
      var togs = document.querySelectorAll(".gamburger");
      for (var i = togs.length - 1; i >= 0; i--) {
        var tog = togs[i];
          (tog.classList.contains("open") === true) ? tog.classList.remove("open") : tog.classList.add("open");
      }
      this.gamb = false
      this.$emit('gamburger', this.gamb);
    }
  },
  mounted () {
    var toggles = document.querySelectorAll(".gamburger");
    for (var i = toggles.length - 1; i >= 0; i--) {
      var toggle = toggles[i];
      toggleHandler(toggle);
    };
    function toggleHandler(toggle) {
      toggle.addEventListener( "click", function(e) {
        e.preventDefault();
        (this.classList.contains("open") === true) ? this.classList.remove("open") : this.classList.add("open");
      });
    }
  },
}
</script>

<style lang="scss" scoped>
#gamburger{
  z-index: 10;
  margin-top: 4px;
  width: 24px;
  height: 24px;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
  position: absolute;
  right:110px;
  display:none; 
  @media screen and (max-width: 480px){
    display: block;
  }
}

#gamburger span{
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  background: #1a924a;;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}

#gamburger.open {
  position: absolute;
  right:110px;
}

/* Icon 3 */

#gamburger span:nth-child(1) {
  top: 0px;
}

#gamburger span:nth-child(2),#gamburger span:nth-child(3) {
  top: 8px;
}

#gamburger span:nth-child(4) {
  top: 16px;
}

#gamburger.open span:nth-child(1) {
  top: 9px;
  width: 0%;
  left: 50%;
}

#gamburger.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color:white;
}

#gamburger.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  background-color:white;
}

#gamburger.open span:nth-child(4) {
  position: fixed !important;
  top: 9px;
  width: 0%;
  left: 50%;
}

/* Icon 4 */


</style>
